import { Stack, styled } from "@mui/material";

export const BranchWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        overflow: "hidden",
        "& .branch-table-box": {
            "& .MuiTableContainer-root": {
                borderRadius: "16px",
                "& .MuiTableHead-root": {
                    "& .MuiTableCell-root": {
                        whiteSpace: "nowrap",
                    },
                    "& .MuiTableCell-root:last-child": {
                        width: "25%",
                    }
                }
            },
        },
    }
})